import { useState as S, useRef as u, useCallback as M, useEffect as X } from "react";
import { p as x } from "../../../main-w4mY2xnX.js";
const E = 50;
function A(h) {
  var d;
  const [e, c] = S(0), i = u(0), r = u(0), n = u(null), { isMobile: s, isDesktop: l, isTablet: a } = x(), f = ((d = n.current) == null ? void 0 : d.offsetWidth) ?? 1, T = (t) => {
    s && (i.current = t.touches[0].clientX);
  }, m = (t) => {
    if (s) {
      const I = t.touches[0].clientX;
      r.current = I - i.current, o();
    }
  }, p = () => {
    s && (r.current < -50 && e < h - 1 ? c((t) => t + 1) : r.current > E && e > 0 && c((t) => t - 1), r.current = 0, o(!0));
  }, o = M(
    (t = !1) => {
      n.current && (t ? n.current.style.transition = "transform 0.3s ease-in-out" : n.current.style.transition = "none", n.current.style.transform = `translateX(${-(e * f) + r.current}px)`);
    },
    [e, f]
  );
  return X(() => {
    o(s), (l || a) && c(0);
  }, [e, o, l, a, s]), {
    sliderRef: n,
    handleTouchStart: T,
    handleTouchMove: m,
    handleTouchEnd: p,
    currentIndex: e,
    setCurrentIndex: c
  };
}
export {
  A as useImageBanner
};
